import { Component } from 'react';

// A render-time throw anywhere below <Routes> used to unmount the whole app
// and leave a blank page — that is exactly what a recipient saw after entering
// a correct PIN on 2026-09-17 (an undefined identifier in the unlocked view).
// This catches it and shows a recoverable message instead.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[send] render error', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="narrow" style={{ margin: '40px auto' }}>
        <div className="card">
          <h1>Something went wrong</h1>
          <p className="lead">This page hit an error while displaying. Your files are still safe.</p>
          <p className="muted">
            Reload the page and enter your PIN again. If it keeps happening, email{' '}
            <a href="mailto:support@intake.dental">support@intake.dental</a> and include the link you opened.
          </p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Reload page</button>
        </div>
      </div>
    );
  }
}
